document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.slideshow');
  sliders.forEach((slider) => {
    new Flickity(slider, {
      cellAlign: 'center',
      contain: true,
      autoPlay: slider.dataset.autoplay === 'true' ? slider.dataset.speed * 1000 : false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
    });
  });
});
